module.exports = __webpack_public_path__ + "images/duravermeer_smallcc88170eb6e6d283e245324fb671c6d8.png";